<template>
	<div>
		<zong-sou v-if="!$route.meta.noSearch" :searchType='searchType'></zong-sou>
		<div style="background: #F6F6F6;padding-bottom: 50px;">
			<div class="wrap">
				
				<div class="main-body">
					<router-view :key='$route.fullPath' :keyWord.sync='searchWord'></router-view>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	import zongSou from '../../components/zongSou.vue'
import {mapState,mapGetters,mapActions,mapMutations} from "vuex";
	export default {
		data() {
			return {
				
				searchWord:'',
				value: '',
				searchType:''
			}
		},
		created() {
			this.searchType = this.$route.meta.type
		},
		components:{
			zongSou
		},
		computed:{
			 ...mapState("globalSearch",{'dw':"searchWord"}),
		},
		watch:{
			dw(newValue,oldValue){
				this.searchWord = newValue
			},
		},
		mounted() {
			
		},
		methods: {
		
		},
		

	}
</script>
<style scoped lang="less">
	.router:last-child {
		color: #222222;
	}

	/deep/.el-input__inner {
		width: 129px;
		height: 40px;
		border: 1px solid #D2D2D2;
	}

	/deep/.el-collapse-item__content {
		padding-bottom: 0;
	}



	.body-left-item-foot {
		border-top: 1px solid #EEEEEE;
		display: flex;
		justify-content: space-between;
		padding: 15px;
	}

	.collapse-inner {
		padding: 10px;
	}

	.checkbox-wrap {
		display: flex;
		justify-content: space-around;
	}

	::v-deep .el-checkbox {
		color: #222222;
		display: block;
		margin: 5px !important;
		position: relative;
	}

	.body-left {
		width: 250px;

	}

	.body-left/deep/.el-collapse-item__header {
		background: #0052D9;
		height: 55px;
		font-size: 18px;
		color: white;
		padding: 0 20px;
	}

	/deep/.el-icon-arrow-right:before {
		content: "\E6E0";
		background: #fff;
		color: #0052D9;
		border-radius: 50%;
		font-weight: bold;
	}

	.header {
		display: flex;
		padding: 15px 0;
		align-items: center;

		&>img {
			width: 16px;
			height: 16px;
		}

		&>p {
			font-size: 16px;
			margin-left: 10px;

			&>span {
				color: #888888;
			}
		}
	}
</style>